<template>
<div class="chapter">
<div class="inner_page">
<div class="chap1" id="ded">
<p class="ct"><a class="xref" href="#/Text/pppthreeletter005#toc">Dedication</a></p>
<p class="ded">To Louis Henry Silverstein<br class="chap"/>1938-2001</p>
<p class="ded">Chairman, Editorial Review Committee<br class="chap"/>who delighted in being known as<br class="chap"/>The Poisoned Pen Press CERC</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppthreeletter004.vue?9476ff64